import { render } from "./OdCollapsibleDetails.vue?vue&type=template&id=a6f09170"
import script from "./OdCollapsibleDetails.vue?vue&type=script&lang=js"
export * from "./OdCollapsibleDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__